import Constants from '../Constants';
import { getRequest, putRequest } from '../utils/axiosClient';

// The Easy Mode reads. Step 1 writes through the updateCase lambda Classic intake already uses, and the
// partner import runs against the PFQ endpoints Classic intake uses, through usePartnerCaseImport.
export const fetchEasyModeCase = async ({ caseId }) => {
  const { data } = await getRequest({
    url: `${Constants.ApiUrl.case.getCaseById}/${caseId}`
  });

  return data?.data ?? null;
};

export const fetchEasyModeRecords = async ({ caseId }) => {
  const { data } = await getRequest({ url: `/api/case/easy-records/${caseId}` });

  return data?.data ?? [];
};

// removing a row only hides it until the next fetch reseeds it from the record, so removal has to
// soft-delete the record itself - the same remove_record endpoint the classic record lists use
export const removeEasyModeRecord = async ({ s3UrlPath }) => {
  await putRequest({ url: Constants.ApiUrl.records.remove, data: { s3Path: s3UrlPath } });
};
